import { NavigationStepperStepWrapper, Arrows } from '@/components/NavigationStepper/ui/styles';
import { COLORS } from '@/styles/colors';
import { Typography } from '@/components/Typography/Typography';
import { ReactNode } from 'react';

export type NavigationStepperStepType = {
  isCompleted: boolean;
  isActive: boolean;
  children: ReactNode;
};

export const NavigationStepperStep = ({ isCompleted, isActive, children }: NavigationStepperStepType) => {
  const stepColor = (isActive && COLORS.green[350]) || (isCompleted && COLORS.grey[650]) || COLORS.grey[600];

  return (
    <NavigationStepperStepWrapper isActive={isActive} isCompleted={isCompleted}>
      <Typography variant='bodySmall' color={stepColor} fontWeight='medium' textAlign='center'>
        {children}
      </Typography>
      <Arrows isActive={isActive} isCompleted={isCompleted} />
    </NavigationStepperStepWrapper>
  );
};
